import React from "react";
import BusinessCard from "./BusinessCard";
import EmptyState from "./EmptyState";
import styles from "./GridView.module.css";

const GridView = React.memo(function GridView({
  shops,
  selectedHubDomain,
  isStoreDeleted,
  onManage,
  onEdit,
  onDelete,
  onRestore,
  onPreview,
  onQRCode,
  emptyType,
  onCreateBusiness,
  createBusinessDisabled,
  createBusinessDisabledReason,
}) {
  const isEmpty = shops.length === 0;

  return (
    <div className={styles.grid}>
      {!isEmpty ? (
        shops.map((shop) => (
          <BusinessCard
            key={shop.bizId}
            shop={shop}
            selectedHubDomain={selectedHubDomain}
            isDeleted={isStoreDeleted(shop)}
            onManage={onManage}
            onEdit={onEdit}
            onDelete={onDelete}
            onRestore={onRestore}
            onPreview={onPreview}
            onQRCode={onQRCode}
          />
        ))
      ) : (
        <div className={styles.emptyWrapper}>
          <EmptyState
            type={emptyType}
            onCreateBusiness={onCreateBusiness}
            createBusinessDisabled={createBusinessDisabled}
            createBusinessDisabledReason={createBusinessDisabledReason}
          />
        </div>
      )}
    </div>
  );
});

export default GridView;
